<script>
    import { scale } from 'svelte/transition';
    export let study;
</script>

<a href="{study.url}" target="_blank" class="study" data-id={study.id} transition:scale="{{ duration: 200 }}">
    <div class="img">
        <img src="{ study.image }" alt="{study.title}" />
    </div>
    <h3>{study.title}</h3>
    <ul>
        { #each study.technologies as tech, i }
            <li>{tech.name}</li>
        { /each }
    </ul>
    <p>
        {study.description}
    </p>
</a>

<style lang="less">
    .study {
        background: var(--color-gray-500);
        color: var(--color-gray-200);
        border-radius: 10px;
        z-index: 0;
        margin-top: 30px;
        border: 1px solid var(--color-gray-375);
        transition: transform .3s ease-in-out, box-shadow .3s ease-in-out;
        box-shadow: 0 2px 12px 0px rgba(0,0,0,.15);
        cursor: pointer;

        @media screen and (min-width: 1025px) {
            &:hover {
                box-shadow: 0 3px 16px 0px rgba(0,0,0,.25);
            }
        }

        .img {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            overflow: hidden;
            border-radius: 10px;

            &:before {
                content: '';
                padding-bottom: 41%;
                width: 100%;
            }

            img {
                position: absolute;
                width: 100%;
                height: auto;
            }
        }

        h3 {
            font-size: 20px;
            line-height: 24px;
            padding: 15px 15px 5px 15px;
            margin: 0;
        }
        ul {
            font-size: 18px;
            line-height: 23px;
            margin: 0 15px;
            padding: 0 0 15px 0;
            width: calc(100% - 30px);
            float: left;
            border-bottom: 1px solid var(--color-gray-375);

            li {
                float: left;
                margin-right: 8px;
                padding-right: 15px;
                font-style: italic;
                position: relative;

                &:before {
                    content: '';
                    position: absolute;
                    right:0;
                    width: 5px;
                    height: 5px;
                    top: 50%;
                    margin-top: -2px;
                    border-radius: 50%;
                    background: var(--color-gray-300);
                }
                &:last-child {
                    &:before {
                        content: none
                    }
                }
            }
        }
        p {
            padding: 15px;
            margin: 0;
            float: left;
        }
    }
</style>